<loader-overlay-component [show]="isloading"></loader-overlay-component>
<div class="mainBody">
    <div class="dmv-search-results inner-home">
        <div class="container">
            <div class="row no-margin">
                <div class="col-6 col-sm-2 mt-4"><a><button class="btn btn-primary btn-back top-back-button" (click)="back()"><i
                                class="fa fa-chevron-left text-left"></i> Back</button></a></div>
                <div class="col-12 col-sm-8 mt-4">
                    <div id="searchResu">Billing Accounts</div>
                    <p id="addthereco"><span>&nbsp;</span></p>
                </div>
                <div class="col-6 col-sm-2 icon-cart mt-4">

                </div>
              
                <div class="row w100 m-auto">
                    <div  *ngIf="errorMessage || sucessMessage">
                        <div class="col-12 alert alert-info" role="alert" *ngIf="sucessMessage" > &nbsp;<span [innerHTML]="sucessMessage"></span></div>
                        <div class="col-12 alert alert-danger" role="alert" *ngIf="errorMessage"> &nbsp;<span [innerHTML]="errorMessage"></span></div>
                     </div>
                    <div class="col-12 col-sm-12">
                        <!-- <div class="col-12 alert-danger" role="alert"> Please correct fields in error. </div>
                        <div class="col-12 asteriskMessage"> *Fields marked with an asterisk are required </div> -->
                        <div class="mt-1 mb-4">
                            <div class="billing-link" [ngClass]="{ 'selected': isRegistrationsVisible }" (click)="toggle('registrations')">
                                <img class="img-fluid" src="{{globalService?.staticResourceURL}}/assets/images/header-image-car-2.svg"> DMV Registrations
                            </div>
                        </div>
                        <div @slideDownUp class="billing-detail" *ngIf="isRegistrationsVisible">
                            <div class="billing-detail-row" *ngIf="!(userStoreService?.getUserProfile()?.billingAccounts?.dmvAccounts?.length)">
                                <div class="col-12 col-sm-12">
                                    <div class="rectangle-wrapper display-webkit-box">
                                        <div class="col-12 alert alert-danger" role="alert">
                                            There are no registrations in your profile.
                                           </div>
                                    </div>
                                </div>
                            </div>
                            <div class="billing-detail-row" *ngFor="let dmvAccounts of userStoreService?.getUserProfile()?.billingAccounts?.dmvAccounts">
                                <div class="row">
                                    <div class="col-10 col-sm-11">
                                        <div class="row">
                                            <div class="col-12 col-sm-12">
                                                <div class="rectangle-wrapper display-webkit-box">
                                                    <div id="pin" class="lh21">{{getLicensePlate(dmvAccounts)?.name}}:</div>
                                                    <div class="merc-number">{{getLicensePlate(dmvAccounts)?.value}}
                                                    </div>
                                                </div>
                                                <div class="rectangle-wrapper">
                                                    <div id="pin">{{getDec(dmvAccounts)?.name}}:</div>
                                                    <div class="merc-number">{{getDec(dmvAccounts)?.value}}</div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-12 col-sm-12">
                                                <div class="billing-disabledLable">
                                                    {{dmvAccounts.agency}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-1 col-sm-1 m-auto">
                                        <div class="deleteIcon m-auto">
                                            <img class="img-fluid" src="{{globalService?.staticResourceURL}}/assets/images/trash.svg" (click)="openModel(dmvAccounts)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                        <div class="mt-1 mb-4" style="display: none;">
                            <div class="billing-link disabled">
                                <img class="img-fluid" src="{{globalService?.staticResourceURL}}/assets/images/header-image-house2.svg">Property Tax
                            </div>
                        </div>
                        <div class="mt-1 mb-4" style="display: none;">
                            <div class="billing-link disabled">
                                <img class="img-fluid" src="{{globalService?.staticResourceURL}}/assets/images/header-image-business2.svg"> Business Tax
                            </div>
                        </div>
                        
                       
                       
                     
                        
                    </div>
               
            </div>

            
            </div>

            <div class="container mt-5  text-center">
                
                <a><button  class="btn btn-primary  btn-continue m-auto" (click)="close()">Close</button></a></div>
        </div>
    </div>
</div>

<confirm-delete-model *ngIf="openConfirmModel" [tag]="removeAccountName" (delete)="delete()" (close)="closePopup()"></confirm-delete-model>
